<template>
  <b-modal
    :id="modalId"
    title="Remove background"
    no-enforce-focus
    @hide="closeHandler"
    @show="reset"
  >
    <b-form-group v-if="!isLoading">
      <b-form-radio
        v-model="isReplace"
        :value="false"
      >
        Copy before removing background
      </b-form-radio>
      <b-form-radio
        v-model="isReplace"
        :value="true"
      >
        Replace image file after removing background
      </b-form-radio>
      <b-form-checkbox
        v-model="isCropToImage"
        :value="true"
        :unchecked-value="false"
      >
        Crop to image
      </b-form-checkbox>
    </b-form-group>

    <div
      v-if="isLoading"
      class="text-center"
      style="min-height: 80px"
    >
      <b-spinner />
    </div>

    <template #modal-footer>
      <ButtonOutline
        variant="outline-primary"
        @click="closeHandler"
      >
        Cancel
      </ButtonOutline>
      <ButtonPrimary
        variant="primary"
        @click="accept"
      >
        Remove background
      </ButtonPrimary>
    </template>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import ButtonPrimary from "@frontend/components/common/atoms/ButtonPrimary.vue";
import ButtonOutline from "@frontend/components/common/atoms/ButtonOutline.vue";
import {MUTATIONS} from "@frontend/store/file-browser-product-selector";
import Requests from "@frontend/services/api/file-browser";
import mixinModal from './mixin'
import {MODALS} from "@frontend/components/modules/file-browser-product-selector/constants";

const { mapGetters, mapMutations, mapActions } = createNamespacedHelpers('fileBrowserProductSelector')

export default {
  name: "RemoveBackgroundModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [mixinModal],
  data: () => ({
    modalId: MODALS.REMOVE_BACKGROUND,
    isReplace: false,
    isLoading: false,
    isCropToImage: true,
  }),
  computed: {
    ...mapGetters(['selectedItems', 'currentFolderId', 'pageSize', 'items'])
  },
  methods: {
    ...mapMutations([MUTATIONS.CLEAR_SELECTION, MUTATIONS.SET_CURRENT_PAGE, MUTATIONS.TOGGLE_SELECTED_ITEMS]),
    ...mapActions(['fetchList', 'unselectAllItems']),
    async accept() {
      let newFileId = null;

      try {
        this.isLoading = true
        const file = await this.fetchFile();
        const formData = new FormData();
        formData.append("file", file);
        formData.append("is_replace", this.isReplace ? 1 : 0);
        formData.append("crop_to_image", this.isCropToImage ? 1 : 0);
        formData.append("path", this.selectedItems[0].url.split('?file=')[1]);
        const response = await Requests.saveRemoveBGImage(formData);

        if (!this.isReplace && response.data?.data?.new_file_id) {
          await this.unselectAllItems();

          newFileId = response.data.data.new_file_id;

          await this.fetchList();

          const lastPage = this.$store.state.fileBrowserProductSelector.pagination.lastPage;
          const currentPage = this.$store.state.fileBrowserProductSelector.pagination.currentPage;

          if (currentPage !== lastPage) {
            this[MUTATIONS.SET_CURRENT_PAGE](lastPage);
          }
        }

        await this.fetchList();

        if (newFileId) {
          const newFile = this.items.find(item => item.id === newFileId);
          if (newFile) {
            await this.unselectAllItems();
            await this.$nextTick();
            this[MUTATIONS.TOGGLE_SELECTED_ITEMS](newFile);
          }
        }

        toastr.success('Removed File Background!');
      } catch (error) {
        const file = await this.fetchFile();
        const maxFileSizeInBytes = 22 * 1024 * 1024;
        file.size > maxFileSizeInBytes ?
          toastr.error('Request entity too large') :
          toastr.error('Remove background failed');
      } finally {
        this.close();
        this[MUTATIONS.CLEAR_SELECTION]();
      }
    },
    reset() {
      this.isReplace = false;
      this.isLoading = false;
      this.isCropToImage = true;
    },
    async fetchFile() {
      const response = await fetch(this.selectedItems[0].full_url)
      const contentType = response.headers.get("content-type");
      const blob = await response.blob();
      
      return new File([blob], "remove_bg_image.jpg", { contentType });
    }
  }
}
</script>

<style scoped lang="scss">

</style>
